import React from 'react';
import Swal from 'sweetalert2';

import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt, faClipboardList } from '@fortawesome/free-solid-svg-icons';



class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        roles: [],
        Modulos: [],
        Permisos: []
    }
    borrarRegistros = (id) => {
        Swal.fire({
            title: 'Está seguro de Eliminar el Rol?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("roles/delroles/" + id)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        Swal.fire('Borrado!', datosRespuesta.data.msj, 'success')
                        this.ListarRoles(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    };

    ListarRoles(page) {
        Swal.showLoading();
        let bname = document.getElementById('bnombre').value;
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("roles/index/" + bname + "?page=" + page)
            .then((datosRespuesta) => {
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a iniciar session', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                console.log(status);
                this.setState({ datosCargados: true, load: '', roles: datosRespuesta.data.data.data, pagina: datosRespuesta.data.data.total, ultimo: datosRespuesta.data.data.last_page, actual: datosRespuesta.data.data.current_page });
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    ListarPermisos(id) {
        Swal.showLoading();
        authAxios.get("roles/permisos/" + id)
            .then((datosRespuesta) => {
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ Permisos: datosRespuesta.data.data });
            })
            .catch(console.log);
        //window.location.href = '/'; window.localStorage.clear();
    }
    pasar = (id) => {
        document.getElementById('id_rol').value = id;
        this.ListarPermisos(id);
        authAxios.get("roles/submodulos/"+id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }

                this.setState({ Modulos: datosRespuesta.data.data });
            })
            .catch(console.log);
    }
    verPermiso = (id) => {
        authAxios.get("roles/verpermisos/" + id)
            .then((datosRespuesta) => {
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                var f = datosRespuesta.data;
                console.log(f);
                document.getElementById('id_modulo').value = f.id_modulo;
                document.getElementById('registrar').value = f.registrar;
                document.getElementById('editar').value = f.editar;
                document.getElementById('eliminar').value = f.eliminar;
                document.getElementById('consultar').value = f.consultar;
                document.getElementById('cargar').value = f.cargar;
                document.getElementById('id').value = id;
            })
            .catch(console.log);
    }
    save() {
        var datos = new FormData(document.getElementById("form_roles"));
        console.log(datos);
        authAxios.post("roles/addpermisos", datos)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.ListarPermisos(document.getElementById('id_rol').value);
                if (datosRespuesta.data.Status) {
                    Swal.fire(
                        'Permiso!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                } else {
                    Swal.fire(
                        'Permiso!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    CambiarPermiso(id,campo){
        var che = document.getElementById(campo+id);
        var valor = 0;
        if (che.checked == true){
            valor = 1;
          } 
          Swal.showLoading();

        authAxios.get("roles/uppermiso/"+id+'/'+campo+'/'+valor)
            .then((datosRespuesta) => {
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a iniciar session', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.ListarPermisos(document.getElementById('id_rol').value);
            })
        .catch(console.log);

    }
    componentDidMount() {
        this.ListarRoles(1);
    }
    render() {
        const { load, roles, pagina, ultimo, actual, Modulos, Permisos } = this.state;
        return (
            <div className="content">
                <div className="modal fade" id="permisoRolesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="nuevoPacienteSubLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="permisoRolesModalLabel">Asignar Permiso</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            <form id="form_roles">
                                                <div className="row g-3">
                                                    <div className="col-md-4">
                                                        <label htmlFor="id_modulo">Modulo</label>
                                                        <input className={"form-control form-control-sm"} type="hidden" name="id_rol" id="id_rol" placeholder="" />
                                                        <input className={"form-control form-control-sm"} type="hidden" name="id" id="id" placeholder="" />
                                                        <select className={"form-select form-select-sm"} name="id_modulo" id="id_modulo">
                                                            <option value="0">Seleccione Modulo</option>
                                                            {
                                                                Modulos.map((item) => (
                                                                    <option value={item.id}>{item.tabla} - {item.titulo}</option>
                                                                ))
                                                            }

                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="cedula">Registrar</label>
                                                        <select className={"form-control form-control-sm"} name="registrar" id="registrar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="cedula">Editar</label>
                                                        <select className={"form-control form-control-sm"} name="editar" id="editar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="cedula">Eliminar</label>
                                                        <select className={"form-control form-control-sm"} name="eliminar" id="eliminar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="cedula">Consultar</label>
                                                        <select className={"form-control form-control-sm"} name="consultar" id="consultar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="cedula">Cargar Archivos</label>
                                                        <select className={"form-control form-control-sm"} name="cargar" id="cargar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label htmlFor="cedula">Aprobar Documentos</label>
                                                        <select className={"form-control form-control-sm"} name="aprobar" id="aprobar">
                                                            <option value="0">No</option>
                                                            <option value="1">Si</option>
                                                        </select>
                                                    </div>
                                                    <button type="button" className="btn btn-primary" onClick={() => this.save()}>Agregar Permiso</button>
                                                </div>
                                            </form>
                                        </div>
                                        <br></br>
                                        <div className="row g-3">
                                            <table className="table table-hover table-condensed table-sm">
                                                <thead className="thead-inverse">
                                                    <tr>
                                                    <th className="align-middle">MENU</th>
                                                        <th className="align-middle">SUBMENU</th>
                                                        <th className="align-middle">REGISTRAR</th>
                                                        <th className="align-middle">EDITAR</th>
                                                        <th className="align-middle">BORRAR</th>
                                                        <th className="align-middle">VER</th>
                                                        <th className="align-middle">CARGAR</th>
                                                        <th className="align-middle">APROBAR</th>
                                                        <th className="align-middle">OPC</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        Permisos.map((item) => (
                                                            <tr key={item.id} >
                                                                <td className="align-middle">{item.id} {item.tabla}</td>
                                                                <td className="align-middle">{item.titulo}</td>
                                                                <td className="align-middle"> <input type="checkbox" title='Registrar datos' id={"registrar"+item.id} checked={item.registrar=='1'?true:false} onClick={()=>this.CambiarPermiso(item.id,'registrar')}/></td>
                                                                        <td className="align-middle"><input type="checkbox" title='editar datos' id={"editar"+item.id} checked={item.editar=='1'?true:false} onClick={()=>this.CambiarPermiso(item.id,'editar')}/></td>
                                                                        <td className="align-middle"><input type="checkbox" title='eliminar datos' id={"eliminar"+item.id} checked={item.eliminar=='1'?true:false} onClick={()=>this.CambiarPermiso(item.id,'eliminar')}/></td>
                                                                        <td className="align-middle"><input type="checkbox" title='consultar lista' id={"consultar"+item.id} checked={item.consultar=='1'?true:false} onClick={()=>this.CambiarPermiso(item.id,'consultar')}/></td>
                                                                        <td className="align-middle"><input type="checkbox" title='cargar archivos' id={"cargar"+item.id} checked={item.cargar=='1'?true:false} onClick={()=>this.CambiarPermiso(item.id,'cargar')}/> </td>
                                                                        <td className="align-middle"><input type="checkbox" title='aprobar' id={"aprobar"+item.id} checked={item.aprobar=='1'?true:false} onClick={()=>this.CambiarPermiso(item.id,'aprobar')}/> </td>
                                                                <td className="align-middle">
                                                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => this.delete(item.id)}>Eliminar</button>
                                                                    <button type="button" className="btn btn-warning btn-sm" onClick={() => this.verPermiso(item.id)}>
                                                                        <FontAwesomeIcon icon={faEdit} />
                                                                    </button>
                                                                </td>
                                                            </tr>

                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        
                                    </div>
                                    
                                    <hr />
                                    <div style={{ marginTop: 0, }} className="row g-3">
                                        <div style={{ marginTop: 0 }} className='col-xs-2 text-center'>
                                            <button type="button" className="btn btn-primary btn-sm" onClick={() => this.save()}>Agregar Permiso</button>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cerrar</button>
                                    </div>
                                </div>
                                <hr />
                                
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddRoles"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Rol</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Roles</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-3">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bnombre" name="bnombre" placeholder="ROL" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarRoles(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">NOMBRE</th>
                                            <th className="align-middle">DESCRIPCIÓN</th>
                                            <th className="align-middle">OPCIONES</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {load}
                                        {
                                            roles.map((itemRoles) => (
                                                <tr key={itemRoles.id}>
                                                    <td>{itemRoles.nombre}</td>
                                                    <td>{itemRoles.descripcion}</td>
                                                    <td>
                                                        <div className="btn-group" role="group" aria-label="">
                                                            <Link
                                                                className="btn btn-primary btn-sm"
                                                                to={"/UpRoles/" + itemRoles.id}
                                                            >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                            </Link>&nbsp;&nbsp;&nbsp;
                                                            <button
                                                                type="button"
                                                                className="btn btn-danger btn-sm"
                                                                onClick={() =>
                                                                    this.borrarRegistros(itemRoles.id)
                                                                }
                                                            >
                                                                <FontAwesomeIcon icon={faTrashAlt} />
                                                            </button>&nbsp;&nbsp;&nbsp;
                                                            <button
                                                                type="button"
                                                                className="btn btn-info btn-sm"
                                                                data-bs-toggle='modal' data-bs-target="#permisoRolesModal"
                                                                onClick={() =>
                                                                    this.pasar(itemRoles.id)
                                                                }
                                                            >
                                                                <FontAwesomeIcon style={{ color: '#FFFFFF' }} icon={faClipboardList} />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRoles(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRoles(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarRol(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRoles(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarRoles(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;